import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { EntryContext } from '../contexts/entryContext';
import DisplayContent from '../utils/DisplayContent';

const BackButton = ({ linkTo, className, buttonSrc, buttonAlt, buttonAriaLabel }) => {
    const { siteAssets } = useContext(EntryContext);
    let navigate = useNavigate();

    function handleClick() {
        navigate(linkTo, { replace: true });
    }

    return (
        <DisplayContent note='Back Button image' isVisible={siteAssets?.backButtonImage?.ref}>
            <input
                className={`game-button ${className ? className : ''}`}
                tabIndex='0'
                type='image'
                src={buttonSrc || siteAssets?.backButtonImage?.ref}
                alt={buttonAlt || siteAssets?.backButtonImage?.alt}
                aria-label={buttonAriaLabel || siteAssets?.backButtonImage?.alt}
                onClick={handleClick}
            />
        </DisplayContent>
    );
};

export default BackButton;
